/**
 * Renders and auto-rotates review cards from the single PfReviews data
 * source (reviews-data.js). Two independent renderers share this file:
 * - default variant: compact card (bottom mini-review), instant swap.
 * - "photo" variant (data-reviews-variant="photo", right-column big card
 *   on the generation page): full-bleed photo + quote overlay, all slides
 *   rendered once and animated with a continuous vertical slide (CSS
 *   transform), looping seamlessly via a duplicated first slide.
 */
(() => {
  function renderPhotoSlide(review) {
    const stars = '★★★★★'.slice(0, review.rating) + '☆☆☆☆☆'.slice(0, 5 - review.rating);
    return `
      <div class="reviews-vertical__slide">
        <img src="${window.PfReviewsAssetUrl(review.image)}" alt="" loading="lazy" width="480" height="640">
        <div class="reviews-vertical__overlay">
          <p class="reviews-vertical__stars" aria-hidden="true">${stars}</p>
          <p class="reviews-vertical__comment">“${review.comment}”</p>
          <p class="reviews-vertical__meta">${review.petName}${review.breed ? ' · ' + review.breed : ''}</p>
        </div>
      </div>
    `;
  }

  function initPhotoCarousel(root) {
    const reviews = window.PfReviews || [];
    if (!reviews.length) return;

    const track = root.querySelector('[data-reviews-track]');
    const intervalMs = parseInt(root.dataset.interval, 10) || 4500;
    const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Loop illusion: render every slide plus a duplicate of the first one
    // at the end. Sliding into that duplicate looks identical to sliding
    // into the real first slide, then we snap back to index 0 with
    // transitions disabled for one frame — seamless continuous scroll.
    track.innerHTML = reviews.map(renderPhotoSlide).join('') + renderPhotoSlide(reviews[0]);

    let index = 0;
    let timer = null;

    function goTo(newIndex, instant) {
      track.style.transition = instant ? 'none' : '';
      track.style.transform = `translateY(-${newIndex * 100}%)`;
    }

    function next() {
      index += 1;
      goTo(index, false);
      if (index === reviews.length) {
        track.addEventListener(
          'transitionend',
          () => {
            index = 0;
            goTo(index, true);
          },
          { once: true }
        );
      }
    }

    function startAutoplay() {
      if (REDUCED_MOTION || reviews.length < 2) return;
      timer = setInterval(next, intervalMs);
    }

    goTo(0, true);
    startAutoplay();
  }

  function renderCard(review) {
    const stars = '★★★★★'.slice(0, review.rating) + '☆☆☆☆☆'.slice(0, 5 - review.rating);
    return `
      <div class="reviews-carousel__photo">
        <img src="${window.PfReviewsAssetUrl(review.image)}" alt="" loading="lazy" width="120" height="120">
      </div>
      <div class="reviews-carousel__body">
        <p class="reviews-carousel__stars" aria-hidden="true">${stars}</p>
        <p class="reviews-carousel__comment">“${review.comment}”</p>
        <p class="reviews-carousel__meta">${review.petName}${review.breed ? ' · ' + review.breed : ''}</p>
      </div>
    `;
  }

  function initCarousel(root) {
    const reviews = window.PfReviews || [];
    if (!reviews.length) return;

    const track = root.querySelector('[data-reviews-track]');
    const dotsContainer = root.querySelector('[data-reviews-dots]');
    const intervalMs = parseInt(root.dataset.interval, 10) || 5000;
    let index = 0;
    let timer = null;

    const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function renderDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = reviews
        .map((_, i) => `<button type="button" class="reviews-carousel__dot${i === index ? ' is-active' : ''}" data-reviews-dot="${i}" aria-label="Avis ${i + 1}"></button>`)
        .join('');
    }

    function show(newIndex) {
      index = (newIndex + reviews.length) % reviews.length;
      track.innerHTML = renderCard(reviews[index]);
      renderDots();
    }

    function next() {
      show(index + 1);
    }

    function startAutoplay() {
      if (REDUCED_MOTION || reviews.length < 2) return;
      stopAutoplay();
      timer = setInterval(next, intervalMs);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    dotsContainer?.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-reviews-dot]');
      if (!btn) return;
      show(parseInt(btn.dataset.reviewsDot, 10));
      startAutoplay();
    });

    show(0);
    startAutoplay();
  }

  window.PfReviewsAssetUrl = window.PfReviewsAssetUrl || ((filename) => filename);

  document.querySelectorAll('[data-reviews-carousel]').forEach((root) => {
    if (root.dataset.reviewsVariant === 'photo') {
      initPhotoCarousel(root);
    } else {
      initCarousel(root);
    }
  });
})();
